import React from "react";
import {useTranslation} from "react-i18next";

function Footer() {
    const {t} = useTranslation()
    const currentYear = new Date().getFullYear()
    const yearRange = `2022-${currentYear}`

    return (
        <footer className="site-footer text-center">
            <p className="site-footer__text">
                {t('footer_text', { year: yearRange })}
            </p>
        </footer>
    );
}

export default Footer;
